import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const ActivatedPropertyModal = observer(_ref => {
  let propertyId = _ref.propertyId,
    trigger = _ref.trigger,
    isOpen = _ref.isOpen,
    isNewBillingEmbedded = _ref.isNewBillingEmbedded;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: trigger,
    variant: "middle",
    noCloseButton: true,
    isOpen: isOpen,
    title: t('add_new_property_flow.your_property_is_activated'),
    noFooter: true
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "success",
    icon: false,
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('general.success')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.property_is_activated'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.what_next_move'))), /*#__PURE__*/React.createElement("div", {
    className: classes.nextSteps
  }, !store.company.companyFeatureStore.disableEnrollResident && /*#__PURE__*/React.createElement("div", {
    className: classes.nextStep
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.nextStepArrow
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.enroll_residents'))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    component: RouterLink,
    to: "/active_dashboard?propertyId=".concat(propertyId, "&enrollModal=true"),
    'custom-attribute': '127-activated-property-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "move-in"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.enroll_new_resident')))), localStorage.getItem('livable_demo_mode') !== 'Demo' && /*#__PURE__*/React.createElement("div", {
    className: classes.nextStep
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.nextStepArrow
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.subscription_settings'))), /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    to: "/payments",
    variant: "actionButton",
    'custom-attribute': '128-activated-property-modal'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.open_subscription_settings'))))), !isNewBillingEmbedded ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    component: RouterLink,
    to: "/active_dashboard",
    'custom-attribute': '129-activated-property-modal'
  }, t('add_new_property_flow.open_home_dashboard')) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: () => {
      navigate("/active_dashboard", {
        replace: true
      });
      // store.homeDashboardStore.selectActivePropertyId('all');
      // store.homeDashboardStore.selectActivePortfolioId('all');
      store.portfolios.getPortfoliosDashboardAsync.run({
        storeCompany: true
      });
    },
    'custom-attribute': '129-activated-property-modal'
  }, t('add_new_property_flow.open_home_dashboard')));
});